'use strict';

exports.__esModule = true;
exports.Loader = undefined;

var _BlockUi = require('./BlockUi');

var _BlockUi2 = _interopRequireDefault(_BlockUi);

var _Loader2 = require('./Loader');

var _Loader3 = _interopRequireDefault(_Loader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Loader = _Loader3.default;
exports.default = _BlockUi2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-block-ui/lib/index.js
// module id = 664
// module chunks = 0